<template>
	<ZyroModal
		max-width="320px"
		max-height="240px"
		:title="$t('builder.userStyles.colors.modal.title')"
		@close-modal="closeModal"
	>
		<p>
			{{ $t('builder.userStyles.modal.subtitle') }}
		</p>
		<template slot="footer">
			<ZyroButton
				v-qa="'userstyles-colors-reset-cancel-btn'"
				@click="closeModal"
			>
				{{ $t('common.cancel') }}
			</ZyroButton>
			<ZyroButton
				v-qa="'userstyles-colors-reset-confirm-btn'"
				theme="primary"
				@click="handleReset"
			>
				{{ $t('common.reset') }}
			</ZyroButton>
		</template>
	</ZyroModal>
</template>

<script>
import { useColorSetsLibrary } from '@/components/builder-drawers/drawers/partials/stylesDrawer/colors/use/useColorSetsLibrary';
import {
	mapActionsGui,
	CLOSE_MODAL,
} from '@/store/builder/gui';

export default {
	setup() {
		const { resetEditedColors } = useColorSetsLibrary();

		return { resetEditedColors };
	},
	methods: {
		...mapActionsGui({ closeModal: CLOSE_MODAL }),
		handleReset() {
			this.resetEditedColors();
			this.closeModal();
		},
	},
};
</script>
